import { toAppError, type AppError } from "@/data/errors";
import { useEffect, useState } from "react";
import type { User } from "firebase/auth";
import { useAuth } from "@/auth/AuthProvider";
import { useSystemStore } from "@/stores/systemStore";
import { findManagedCompanies, type ManagedCompany } from "@/data/firestore/membershipRepository";

export function useManagedCompanies(enabled = true) {
  const { currentUser, authLoading } = useAuth();
  const { uid, adminAccessResolved, isSystemAdmin, error: adminError } = useSystemStore();
  const [result, setResult] = useState<{ user: User; companies: ManagedCompany[]; error: AppError | null } | null>(null);

  useEffect(() => {
    if (!enabled || authLoading || !currentUser || currentUser.isAnonymous || uid !== currentUser.uid || !adminAccessResolved || isSystemAdmin || adminError) return;
    let active = true;
    void findManagedCompanies(currentUser.uid)
      .then((companies) => { if (active) setResult({ user: currentUser, companies, error: null }); })
      .catch((error) => { if (active) setResult({ user: currentUser, companies: [], error: toAppError(error) }); });
    return () => { active = false; };
  }, [enabled, authLoading, currentUser, uid, adminAccessResolved, isSystemAdmin, adminError]);

  const resolving = authLoading || Boolean(currentUser && (uid !== currentUser.uid || !adminAccessResolved));
  const companies = !enabled || !currentUser || currentUser.isAnonymous || isSystemAdmin || adminError ? []
    : result?.user === currentUser ? result.companies : null;
  return { currentUser, isSystemAdmin, adminError, resolving, companies, membershipError: result?.user === currentUser ? result.error : null };
}
